//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { cloneDeep, isEmpty, isUndefined, isEqual, find, isNull } from 'lodash'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import { InitKioskCustomerRequestStatus, InitKioskCustomerRequestAction } from './Components'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import { DatePickerFilterLabel, TableHeaderCreateButton } from '../../theme/GlobalCss'
import { initKioskManagerActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import { uriList } from '../../routings/settings/RouteList'
import Table from '../../components/Table'
import Tooltip from '../../components/Tooltip/Tooltip'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import Theme from '../../theme/theme'
import UseCheckAll from '../../hooks/UseCheckAll'
import UseDatePicker from '../../hooks/UseDatePicker'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Calendar from '../../assets/icones/global/calendar.svg'
import userPrivileges from '../../constants/PrivilegesList'
import urlExport from '../../constants/UrlExport'

//////STYLED//////
const InitKioskCustomerManagerWrapper = styled.div`
	position: relative;
`
const DatePickerCreationIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const TextModalWrapper = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`
const RequestActionLabel = styled.div`
	margin-right: 5px;
	line-height: 32px;
`
const RequestActionWrapper = styled.div`
	display: flex;
	align-items: center;
`
//////STYLED//////

const InitKioskCustomerManager = () => {
	const {
		user,
		translations,
		userKioskPerimeter,
		initKioskCustomerManager,
		initKioskCustomerFilters,
		isSearchfieldUpdated,
		currentColumn,
		currentDir,
	} = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			userKioskPerimeter: state.user.identity.kioskSelected,
			initKioskCustomerManager: state.initKioskCustomerManager,
			userRolePrivileges: state.user.identity.rolePrivileges,
			initKioskCustomerFilters: state.initKioskCustomerManager.header,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	const [swytch, setSwytch] = useState(false)

	const history = useHistory()

	// Date picker
	const [dateCreationShowModal, dateCreationOpenDateModalHandler, dateCreationRenderModal, dateCreationStateDate, setStartDate, setEndDate] =
		UseDatePicker({})

	// Paging
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'idRequest', nameDir: 'asc' })

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const actionsInitKioskManager = bindActionCreators(initKioskManagerActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	// Columns
	const [columns, setColumns] = useState([])
	/////////////////////////////// HANDLER //////////////////////////////////////

	const handlePagingInitKioskCustomerManager = (paging) => {
		const pg = {
			...paging,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'idRequest',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'asc',
			},
		}
		setPaging(pg)
		// Test user, to get the good call accordingly
		actionsInitKioskManager.getKiosksCustomerView(handleFilterSend(), pg)
	}

	// handler search bar
	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSelectedRequiredAction = () => {
		let filtersCP = cloneDeep(filters)
		let str_filters = handleFilterSend()
		str_filters.filtersSelection.onlyWithRequiredAction.filterElements[0].active =
			!filters.filtersSelection?.onlyWithRequiredAction.filterElements[0].active
		filtersCP.filtersSelection.onlyWithRequiredAction.filterElements[0].active =
			!filters.filtersSelection?.onlyWithRequiredAction.filterElements[0].active
		setFilters(filtersCP)
		actionsInitKioskManager.getKiosksCustomerView(str_filters, paging)
	}

	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change
		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'idRequest', nameDir: 'asc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsInitKioskManager.getKiosksCustomerView(handleFilterSend(), pg)
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		return {
			...filtersOut,
			withFilters: true,
			datesRange: {
				dateStart: dateCreationStateDate.date.startDate,
				dateEnd: dateCreationStateDate.date.endDate,
			},
		}
	}

	// Redirect according to status
	const handleRedirect = (row, readOnly = false) => {
		//const definitionStatus = find([1, 2, 3, 4, 5, 19], (o) => o === row.requestStatus.id) ? true : false
		const bankStatus = row.requestStatus.id === 6 ? true : false
		const articleStatus = row.requestStatus.id === 7 ? true : false
		const implantationStatus = row.requestStatus.id === 8 ? true : false
		const pricesStatus = row.requestStatus.id === 9 ? true : false
		const recapStatus = row.requestStatus.id >= 10 && row.requestStatus.id <= 19 ? true : false

		let urlPush = ''
		let step = ''

		/* if (definitionStatus) {
			urlPush = `${uriList.initKiosks}${uriList.initKioskCustomerManager}${uriList.kioskCreationDefinition}/${row.id}`
			step = 'definition'
		} else  */ if (bankStatus) {
			urlPush = `${uriList.initKiosks}${uriList.initKioskCustomerManager}${uriList.kioskBankDetails}/${row.id}`
			step = 'bankDetails'
		} else if (articleStatus) {
			urlPush = `${uriList.initKiosks}${uriList.initKioskCustomerManager}${uriList.kioskAddItem}/${row.id}`
			step = 'addItems'
		} else if (implantationStatus) {
			urlPush = `${uriList.initKiosks}${uriList.initKioskCustomerManager}${uriList.kioskImplantation}/${row.id}`
			step = 'initKioskImplantation'
		} else if (pricesStatus) {
			urlPush = `${uriList.initKiosks}${uriList.initKioskCustomerManager}${uriList.kioskAddPrices}/${row.id}`
			step = 'addPrices'
		} else if (recapStatus) {
			urlPush = `${uriList.initKiosks}${uriList.initKioskCustomerManager}${uriList.kioskSummary}/${row.id}`
			step = 'summary'
		} else {
			// Default
			urlPush = `${uriList.initKiosks}${uriList.initKioskCustomerManager}${uriList.kioskCreationDefinition}/${row.id}`
			step = 'definition'
		}

		if (urlPush !== '') {
			actionsInitKioskManager.setRequestCustomerParams(row.id, row.requestStatus.id, readOnly, step)
			history.push(urlPush)
		}
	}

	/////////////////////////////// CONFIG //////////////////////////////////////
	useEffect(() => {
		setColumns([
			{
				columnReferential: 'kioskInCreation_requestId',
				dataHook: 'requestId',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_requestId'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'idRequest',
			},
			{
				columnReferential: 'kioskInCreation_requestName',
				dataHook: 'requestName',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_requestName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'label',
			},
			{
				columnReferential: 'kioskInCreation_requestStatus',
				dataHook: 'requestStatus.id',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_requestProgression'],
				sortable: true,
				isAuthorize: true,
				component: InitKioskCustomerRequestStatus,
				sortableId: 'progress',
			},
			{
				columnReferential: 'kioskInCreation_requiredAction',
				dataHook: 'requiredAction',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_requiredAction'],
				sortable: false,
				isAuthorize: true,
				component: InitKioskCustomerRequestAction,
			},
			{
				columnReferential: 'kioskInCreation_store',
				dataHook: 'storeLabelToDisplay',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_store'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'companyStore.labelToDisplay',
			},
			{
				columnReferential: 'kioskInCreation_kioskCode',
				dataHook: 'kioskCode',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_kioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'reqKiosk.labelToManufacturer',
			},
			{
				columnReferential: 'kioskInCreation_customerKioskName',
				dataHook: 'customerKioskCode',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_customerKioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'reqKiosk.description',
			},
			{
				columnReferential: 'kioskInCreation_kioskName',
				dataHook: 'kioskName',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_kioskName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'reqKiosk.labelToOwner',
			},
			{
				columnReferential: 'kioskInCreation_installationDate',
				dataHook: 'dateInstall',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_installDesired'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.dateInstall) ? moment(props.row.dateInstall).format('DD/MM/YYYY') : '-'),
				sortableId: 'mi.dateInstallation',
			},
			{
				columnReferential: 'kioskInCreation_kioskModel',
				dataHook: 'kioskModel',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_kioskModel'],
				sortable: true,
				isAuthorize: false,
				toTranslate: true,
				sortableId: 'reqKiosk.kioskModel.label',
			},
			{
				columnReferential: 'kioskInCreation_displayStandNumber',
				dataHook: 'displayStandsNumber',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_rackNumber'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'racksNumber',
			},
			{
				columnReferential: 'kioskInCreation_lockerNumber',
				dataHook: 'lockersNumber',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_lockerNumber'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'lockersNumber',
			},
			{
				columnReferential: 'kioskInCreation_creationDate',
				dataHook: 'dateCreated',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_creationDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.dateCreated) ? moment(props.row.dateCreated).format('DD/MM/YYYY HH:mm') : '-'),
				sortableId: 'dateCreated',
			},
			{
				columnReferential: 'kioskInCreation_userToRequest',
				dataHook: 'userToRequest',
				headerName: translations['page__initKiosk__kioskCreation_tableHeader_manager'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'userCreated.lastName',
			},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				checkRight: userPrivileges.action[23],
				withIcons: false,
				rest: {
					tooltipPart: 'initKioskCustomerManager',
					paperActionsList: [
						{
							name: translations['page__initKiosk__kioskCreation_tableHeader_modalAction_button_configure'],
							clickAction: (row) => {
								handleRedirect(row)
							},
							isVisible: (row) => {
								return row.canConfigure
							},
							//icon: Start,
							translationKey: 'tooltip__admin__initKiosk__configureRequest',
						},
						{
							name: translations['page__initKiosk__kioskCreation_tableHeader_modalAction_button_assignKiosk'],
							clickAction: (row) => {
								handleRedirect(row)
							},
							isVisible: (row) => {
								return row.canKioskAffectRequest
							},
							//icon: Start,
							translationKey: 'tooltip__admin__initKiosk__assignKiosk',
						},
						/*{
								name:translations['tooltip__admin__initKiosk__finalizeRequest'],
								clickAction: row => {handleFinalizeRequest(row)},
								isVisible : (row) => {return row.canFinalizeRequest},
								iconDef: Start,
								translationKey: "tooltip__admin__initKiosk__finalizeRequest"
							},*/
						/*{
								name:translations['page__initKiosk__kioskCreation_tableHeader_modalAction_button_cancelRequest'],
								clickAction: row => {handleOpenModals(row, "handleModalCancelRequest")},
								isVisible : (row) => {return row.canCancelRequest},
								iconDef: CancelRequest,
								translationKey: "tooltip__admin__initKiosk__cancelRequest"
							},*/
						{
							name: translations['tooltip__admin__initKiosk__see'],
							clickAction: (row) => {
								handleRedirect(row, true)
							},
							isVisible: (row) => {
								return row.canShow
							},
							//icon: SeeIcon,
							translationKey: 'tooltip__admin__initKiosk__see',
						},
					],
				},
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 21,
		labelPageTable: 'kioskInCreation',
	}

	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},

			dateLists: [
				() => (
					<Fragment>
						<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
							{translations['common__fastFilter_generationDate']}
						</label>
						<DatePickerCreationIcon onClick={dateCreationOpenDateModalHandler} />
						<DatePickerFilterLabel>
							<span>
								{translations['page__global__admin__header_datePicker_from']}{' '}
								{isEqual(dateCreationStateDate.date.startDate, {})
									? moment(new Date()).subtract(3, 'months').format('DD/MM/YYYY HH:mm')
									: moment(dateCreationStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
							</span>
							<span>
								{translations['page__global__admin__header_datePicker_to']}{' '}
								{isEqual(dateCreationStateDate.date.endDate, {})
									? moment(new Date()).format('DD/MM/YYYY HH:mm')
									: moment(dateCreationStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
							</span>
						</DatePickerFilterLabel>
					</Fragment>
				),
			],
		},
		paging: { fnSendTo: (paging) => handlePagingInitKioskCustomerManager(paging) },
	})
	const [configTable, setConfigTable] = useState({})

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		return function cleanUp() {
			actionsInitKioskManager.resetDataCustomer()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue) return
		handleSubmit()
	}, [filters.searchField])

	useEffect(() => {
		setFilters(initKioskCustomerFilters)
		setPrevFilter(initKioskCustomerFilters)
	}, [translations, initKioskCustomerFilters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.name = translations['page__initKiosk__kioskCreation_title']

		cfg.paging = {
			totalElements: initKioskCustomerManager.paging.totalElements,
			totalPages: initKioskCustomerManager.paging.totalPages,
			fnSendTo: (paging) => handlePagingInitKioskCustomerManager(paging),
		}

		cfg.actions.rest = [
			() => (
				<RequestActionWrapper>
					<RequestActionLabel>{translations['page__kioskRequestCustomer__filter_requiredActionOnly']} :</RequestActionLabel>
					<input
						type="checkbox"
						checked={filters.filtersSelection?.onlyWithRequiredAction.filterElements[0].active}
						onClick={() => handleSelectedRequiredAction()}
					/>
				</RequestActionWrapper>
			),

			() => (
				<DropdownCheckbox
					title={translations['page__initKiosk__kioskCreation_filters_store']}
					data={filters.filtersSelection?.stores.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'stores'}
				/>
			),

			() => (
				<DropdownCheckbox
					title={translations['page__initKiosk__kioskCreation_filters_progressStatus']}
					data={filters.filtersSelection?.kioksRequestStatus.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'kioksRequestStatus'}
				/>
			),
		]

		cfg.actions.dateLists = [
			() => (
				<Fragment>
					<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
						{translations['page__initKiosk__kioskCreation_filters_creationDate']}
					</label>
					<DatePickerCreationIcon onClick={dateCreationOpenDateModalHandler} />
					<DatePickerFilterLabel>
						<span>
							{translations['page__global__admin__header_datePicker_from']}{' '}
							{isEqual(dateCreationStateDate.date.startDate, {})
								? moment(new Date()).subtract(3, 'months').format('DD/MM/YYYY HH:mm')
								: moment(dateCreationStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
						</span>
						<span>
							{translations['page__global__admin__header_datePicker_to']}{' '}
							{isEqual(dateCreationStateDate.date.endDate, {})
								? moment(new Date()).format('DD/MM/YYYY HH:mm')
								: moment(dateCreationStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
						</span>
					</DatePickerFilterLabel>
				</Fragment>
			),
		]

		setConfigTableTitle(cfg)
	}, [filters, translations, dateCreationStateDate])

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(searchValue)) {
			setSwytch(true)
		}
	}, [user, searchValue])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)
		cfgCp.export = {
			privilege: userPrivileges.export[17],
			url: urlExport[16],
			bd: {
				filtersSelection: filters.filtersSelection,
				datesRange: { dateEnd: dateCreationStateDate.date.endDate, dateStart: dateCreationStateDate.date.startDate },
				searchField: searchValue,
				withFilters: true,
			},
		}

		setConfigTable(cfgCp)
	}, [translations, filters])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return
		if (swytch) {
			let state_date = {}

			// Or default case
			state_date.startDate = moment().startOf('day').subtract(3, 'months').toDate()
			state_date.endDate = moment().hours(23).minutes(59).toDate()

			// And for state of datepicker
			setStartDate(moment(state_date.startDate).toDate())
			setEndDate(moment(state_date.endDate).toDate())

			const filtersCp = {
				withFilters: searchValue?.length > 0 ? true : false,
				filtersSelection: null,
				searchField: filters.searchField,
				datesRange: {
					dateStart: state_date.startDate,
					dateEnd: state_date.endDate,
				},
				searchFieldUpdated: false,
			}
			actionsInitKioskManager.getKiosksCustomerView(filtersCp)
			actionsColumns.setColumns([])

			setFilters(filtersCp)
		}
	}, [swytch, translations])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			actionsInitKioskManager.getKiosksCustomerView(handleFilterSend(), paging)
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(initKioskCustomerManager) && !isUndefined(initKioskCustomerManager)) {
			cfg.paging = {
				totalElements: initKioskCustomerManager.paging.totalElements,
				totalPages: initKioskCustomerManager.paging.totalPages,
				fnSendTo: (paging) => handlePagingInitKioskCustomerManager(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [initKioskCustomerManager])

	useEffect(() => {
		if (dateCreationStateDate.showModal) {
			actionsInitKioskManager.getKiosksCustomerView(handleFilterSend(), paging)
		}
	}, [dateCreationShowModal])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={initKioskCustomerManager.items}
				inputConfig={configTable}
				tableReferential={tableReferential}
				currentPaging={paging}
				actionSort={actionsInitKioskManager.getKiosksCustomerView}
			/>
		)
	}, [initKioskCustomerManager, columns, configTable, translations, paging])

	return (
		<Fragment>
			{/*<Modals
				title={translations['modal__initKiosk__kioskCreation__title__cancelRequest']}
				level='error'
				icon={true}
				showModal={ showModalCancelRequest }
				closeModalHandler={ handleCloseModals }
			>
				<TextModalWrapper>
					<TextModal>{translations['modal__initKiosk__kioskCreation__body__cancelRequest']} </TextModal>
				</TextModalWrapper>
				<ButtonWrapper>
					<Button
						actionHandler={ handleCloseModals }
						text={ translations['common__text__cancel'] }
						bgColor={ Theme.colors.error }
						margin='true'
					/>
					<Button
						actionHandler={ () => handleCancelRequest(row)}
						text={translations['common__text__validate']}
						bgColor={ Theme.colors.validation }
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>*/}
			{dateCreationRenderModal()}
			<InitKioskCustomerManagerWrapper>
				{!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.buttonAction[1])) && (
					<Tooltip tooltipId={'addButton'} translationsKey={'tooltip__admin__initKiosk__kioskCreate'}>
						<TableHeaderCreateButton to={`${uriList.initKiosks}${uriList.initKioskCustomerManager}${uriList.kioskCreationDefinition}`} />
					</Tooltip>
				)}
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</InitKioskCustomerManagerWrapper>
		</Fragment>
	)
}

InitKioskCustomerManager.propTypes = {}

InitKioskCustomerManager.defaultPropTypes = {}

export default InitKioskCustomerManager
